import { render } from "./site-issue-summary-filter.vue?vue&type=template&id=5e4ae622&ts=true"
import script from "./site-issue-summary-filter.vue?vue&type=script&lang=ts"
export * from "./site-issue-summary-filter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__